import { mdiCursorDefaultClick } from '@mdi/js';
import Icon from '@mdi/react';
import HeaderButton from 'components/layouts/components/Header/HeaderButton';
import { useTutorial } from 'store/redux/states/ui/ui.hooks';
import { Tooltip } from 'antd';
import React from 'react';

const Tour = () => {
  const [tutorial, setTutorialOpen] = useTutorial();

  const handleClick = (_) => {
    setTutorialOpen(true);
  };

  return (
    <Tooltip placement='bottom' title='Start Tour' destroyTooltipOnHide mouseEnterDelay={0.1}>
      <HeaderButton disabled={tutorial} color='darkText' onClick={handleClick}>
        <Icon path={mdiCursorDefaultClick} />
      </HeaderButton>
    </Tooltip>
  );
};

export default Tour;
